import { baseService } from 'services';
import { ReliantResponse } from 'interface/apiInterface';
import {
  listDeploymentVersionsEP,
  getDeploymentVersionEP,
} from 'services/constants';
import { AxiosError } from 'axios';
import {
  IListDeploymentVersionsRequest,
  IListDeploymentVersionsResponse,
  IGetDeploymentVersionRequest,
  IDeploymentVersion,
} from 'interface/deploymentInterface';

export const listDeploymentVersions = async (
  data: IListDeploymentVersionsRequest,
): Promise<ReliantResponse<IListDeploymentVersionsResponse>> => {
  try {
    const response = await baseService.post<IListDeploymentVersionsResponse>(
      listDeploymentVersionsEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const getDeploymentVersion = async (
  data: IGetDeploymentVersionRequest,
): Promise<ReliantResponse<IDeploymentVersion>> => {
  try {
    const response = await baseService.post<IDeploymentVersion>(
      getDeploymentVersionEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};
